module.exports = __webpack_public_path__ + "static/BryanDeloesteResume2017.9bba5546.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/BryanDeloesteResume2017.pdf
// module id = 135
// module chunks = 35783957827783 213720915766396